import type { Resource } from '../../';
export const search_box_search: Resource = {"default":"Search"};
